import { FC } from 'react';
import { Link } from 'react-router-dom';
import type { CountryInfo } from '../../types/country-info';
import { CurrencyChangeButton } from '../CurrencyChangeButton';
import DiscordIcon from './icons/discord.svg?react';
import TwitterIcon from './icons/twitter.svg?react';

type FooterViewLink = {
  id: string
  link: string
  label: string
}

type FooterTranslations = {
  joinTheCommunity: string
}

type FooterViewProps = {
  links: FooterViewLink[]
  footerTranslations: FooterTranslations
  currentYear: number
  discordUrl: string;
  twitterUrl: string;
  appLinks?: {
    ios?: string;
    android?: string;
  }
  getCookie: (e: React.MouseEvent<HTMLButtonElement>) => void;
  currencyChangeCountryInfo?: CountryInfo;
  onCurrencyChangeClick?: () => void;
}

// TODO
// move assets to shared cdn or main cdn https://web-shop-assets.s3.eu-central-1.amazonaws.com
export const FooterView: FC<FooterViewProps> = ({
  links,
  footerTranslations,
  currentYear,
  discordUrl,
  twitterUrl,
  appLinks,
  getCookie,
  currencyChangeCountryInfo,
  onCurrencyChangeClick,
}: FooterViewProps) => (
  <footer
    className="layout-padding-x z-50 flex flex-col gap-8 bg-shell pb-[60px] pt-2 md:pt-6"
  >
    <div
      className="objektiv-mk3-sm flex flex-col-reverse justify-between gap-6 py-4 sm:flex-row"
    >
      <div className="flex flex-col gap-4 md:gap-6">
        <span>{footerTranslations.joinTheCommunity}</span>
        <div className="flex gap-7">
          <a className="size-10" href={discordUrl} target="_blank" rel="noreferrer">
            <DiscordIcon />
          </a>
          <a className="flex size-10 items-center justify-center" href={twitterUrl} target="_blank" rel="noreferrer">
            <div className="size-8">
              <TwitterIcon />
            </div>
          </a>
        </div>
      </div>
      {appLinks && (
        <div className="flex gap-4">
          {appLinks.android && (
            <Link to={appLinks.android}>
              <img
                src="https://web-shop-assets.s3.eu-central-1.amazonaws.com/general/play-market.png"
                alt="play-market"
                className="h-[44px] w-[146px] md:h-[52px] md:w-[178px]"
              />
            </Link>
          )}
          {appLinks.ios && (
            <Link to={appLinks.ios}>
              <img
                src="https://web-shop-assets.s3.eu-central-1.amazonaws.com/general/app-store.png"
                alt="app-store"
                className="h-[44px] w-[130px] md:h-[52px] md:w-[158px]"
              />
            </Link>
          )}
        </div>
      )}
      {currencyChangeCountryInfo && onCurrencyChangeClick && (
        <CurrencyChangeButton countryInfo={currencyChangeCountryInfo} onClick={onCurrencyChangeClick} />
      )}
    </div>
    <div className="h-0.5 w-full bg-separator" />
    <div className="flex flex-col justify-between gap-9 sm:flex-row">
      <div className="flex items-start gap-7">
        {links.map(({ id, link, label }) => (
          <Link
            className="uppercase"
            key={id}
            to={link}
            target="_blank"
            rel="noreferrer"
          >
            {label}
          </Link>
        ))}
        <button
          type="button"
          className="uppercase"
          onClick={getCookie}
        >
          COOKIE
        </button>
      </div>
      <div className="flex">
        <div
          className="flex flex-row-reverse items-center gap-6 md:flex-row md:gap-7 "
        >
          <img
            src="https://web-shop-assets.s3.eu-central-1.amazonaws.com/general/fab-logo-white.svg"
            alt="fab-logo"
            className="h-[48px] w-[128px] md:h-[72px] md:w-[142px]"
          />
          <img
            src="https://web-shop-assets.s3.eu-central-1.amazonaws.com/general/name-logo-white.svg"
            alt="name-logo"
            className="h-[22px] w-[90] md:h-[72px] md:w-[200px]"
          />
        </div>
      </div>
    </div>
    <div className="flex md:justify-end">
      <span className="inter-sm text-gray">
        ©
        {currentYear}
        {' '}
        – Pixion Games | All Rights Reserved
      </span>
    </div>
  </footer>
);
